export default {
  required: '請輸入',
  requiredSelect: '請選擇',
  basicInfo: '基礎信息',
  providerType: '服務商類型',
  providerTypeCustom: '自定義',
  serverType: '服務器API/SMTP',
  serverTypeAPI: 'API',
  serverTypeSMTP: 'SMTP',
  apiKey: 'API',
  apiKeyPlaceholder: '請輸入郵箱服務API',
  apiSecret: 'API SECRET',
  apiSecretPlaceholder: '請輸入郵箱服務API secret',
  smtpHost: '服務器地址（SMTP）',
  smtpHostPlaceholder: '請輸入郵箱服務器地址',
  smtpPort: '端口號（Port）',
  smtpPortPlaceholder: '請輸入端口號（例如：457或587）',
  encryption: '加密協議',
  encryptionSSL: 'SSL',
  encryptionTLS: 'TLS',
  encryptionNone: 'None',
  senderPassword: '發件人密碼/授權碼',
  senderPasswordPlaceholder: '請輸入授權密碼',
  senderEmail: '發件人郵箱地址',
  senderEmailPlaceholder: '請輸入發件人郵箱地址',
  senderName: '發件人用戶名',
  senderNamePlaceholder: '請輸入發件人用戶名',
  sendTest: '郵件發送測試',
  testRecipient: '測試收件人郵箱',
  testRecipientPlaceholder: '請輸入收件郵箱',
  sendTestEmail: '發送測試郵件',
  sendTestSuccess: '測試郵件發送成功',
  sendTestFail: '測試郵件發送失敗',
  save: '保存配置',
  saveSuccess: '保存成功',
  sendLog: '郵件發送記錄',
  logSendTime: '發送時間',
  logRecipient: '收件人',
  logStatus: '狀態',
  logTemplateName: '模板名稱',
};
